import * as DIALOG from "../files/components/dialogs.i18n";
import * as GENERIC_FILTER_TOOLBAR from "../files/components/genericFilterToolbar.i18n";
import * as HOURGLASS from "../files/components/hourglass.i18n";
import * as NOTIFICATIONS from "../files/components/notifications.i18n";

export const genericFilterToolbar = GENERIC_FILTER_TOOLBAR;
export const dialog = DIALOG;
export const notifications = NOTIFICATIONS;
export const hourglass = HOURGLASS;
